module.exports = __webpack_public_path__ + "assets/96397e7ebaac84fb7b69f7ccc450089d.png";